import { FC, SVGAttributes } from 'react';

const Receipt: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5 17C6.17 17 6.17 20.5 7.33 20.5C8.5 20.5 8.5 18 9.67 18C10.83 18 10.83 20.5 12 20.5C13.17 20.5 13.17 18 14.33 18C15.5 18 15.5 20.5 16.67 20.5C17.83 20.5 17.83 17 19 17V5C19 3.895 18.105 3 17 3H7C5.895 3 5 3.895 5 5V17Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.5 9.5H8.51"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 9.5H15.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.5 13.5H8.51"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 13.5H15.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Receipt;
